(function ($) {

    /**
     * @var Datatable
     */
    let dt;

    /**
     * Constructor
     *
     * @param options
     * @constructor
     */
    function BusinessWantedListing(options) {
        console.log('BusinessWantedListing initialization');

        if (!options) {
            throw new Error('No options passed to BusinessWantedListing constructor');
        }

        this.options = $.extend({}, BusinessForSaleListing.defaults, options);
        this.setup();
    }

    BusinessWantedListing.prototype.setup = function () {
        let self = this;
        this.initDatatable();
        let body = $('body');

        body.on('click', '.link-delete', function (event) {
            let businessID = $(event.target).closest('ul').data('business-id')
            console.log(businessID);

            //TODO: HACK for set business ID to modal. Have error when tried call modal directly through JS
            let modal = $('#delete-confirmation-modal');
            modal.find('#delete-business-button').data('business-id', businessID)
            modal.find('.modal-body').empty().append('Are you sure you want to delete your listing? This action is permanent.');

        });

        body.on('click', '#delete-business-button', function (event) {
            let businessID = $(event.target).data('business-id');
            console.log(businessID);
            let fd = new FormData();
            fd.append('action', 'delete');
            fd.append('businessID', businessID);
            self.sendRequest(fd);
        });
    }

    /**
     * Init datatable
     */
    BusinessWantedListing.prototype.initDatatable = function () {
        dt = $('#business-wanted-datatable').DataTable({
            searching: false,
            lengthChange: false,
            "autoWidth": false,
            responsive: {
                details: true
            },
            "language": {
                "emptyTable": "You haven't added any listings yet."
            },
            "columnDefs": [
                {
                    orderable: false,
                    targets: -1
                }
            ],
            "order": []
        });
    }

    /**
     * Send AJAX request
     */
    BusinessWantedListing.prototype.sendRequest = function (fd) {
        let self = this;
        console.log('Send request');
        console.log(fd);

        jQuery.ajax({
            type: 'POST',
            url: self.options.apiRoute,
            data: fd,
            processData: false,
            contentType: false,
            dataType: "json",
            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-WP-Nonce', self.options.nonce);
            },
            success: function (response) {
                self.parseResponse(response);
            },
            error: function (data) {
                console.log(data);
            }
        });
    }

    /**
     * Parse response
     *
     * @param response
     */
    BusinessWantedListing.prototype.parseResponse = function (response) {
        console.log(response);
        if (response.status !== 'success') {
            return;
        }

        let businessRow = $("[data-business-id='" + response.business_id + "']").closest('tr');
        console.log(businessRow);

        if (response.action === 'delete') {
            dt.row(businessRow).remove().draw();
        }
    }

    BusinessWantedListing.defaults = {};
    window.BusinessWantedListing = BusinessWantedListing;

})(jQuery);